module.exports = __webpack_public_path__ + "assets/media/main.a279dc32.ogg";